<div class="min-h-0 flex-1 overflow-y-auto">
  @if (store.foldersLoadError()) {
    <p role="alert" class="px-8 py-4">Could not load folders.</p>
    <app-button2 appearance="secondary-text" (click)="store.loadAll()">Retry</app-button2>
  } @else if (store.foldersLoading() && !store.foldersLoaded()) {
    <app-loading-indicator [inPanel]="true">Loading folders</app-loading-indicator>
  } @else {
    @for (folder of pagedRows(); track folder.id) {
      <app-boards-folder-card [folder]="folder"
        (open)="openFolder.emit({ id: folder.id, selectAll: $event })"
        (duplicated)="openFolder.emit({ id: $event, selectAll: false })"
        (boardCreated)="boardCreated.emit({ folderId: folder.id, boardId: $event })" />
    } @empty {
      <app-no-content-stub class="h-full" imageSrc="assets/placeholders/empty-boards.svg" [size]="75">
        <p class="text-base font-medium text-gray-900 text-center">{{ search().trim() ? 'No folders match your search' : 'No folders' }}</p>
      </app-no-content-stub>
    }
  }
</div>
<app-pagination2 class="border-t border-border" [(page)]="page" [pageSize]="pageSize" [totalItems]="rows().length" (refresh)="store.loadAll()" />
